import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';

const Logo: React.FC = (): ReactElement => (
  <Link
    to="/acasa"
    className="cursor-pointer min-w-[230px] h-[92px]"
    onClick={() => {
      window.scroll(0, 0);
    }}
  >
    <img src="static/resources/logo.png" alt="Logo" className="h-full" />
  </Link>
);

export default Logo;
